import { ArrowRight, LucideIcon } from 'lucide-react';
import { useIntl } from 'react-intl';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTES, categoryMessages } from '../constants';

interface ServiceCardProps {
  icon: LucideIcon;
  id: string;
}

export function ServiceCard({ icon: Icon, id }: ServiceCardProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  return (
    <div
      className='bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer'
      onClick={(e) => {
        e.preventDefault();
        navigate(
          `${generatePath(ROUTES.services)}?category=${encodeURIComponent(id)}`,
        );
      }}
    >
      <div className='text-blue-600 mb-4'>
        <Icon className='w-8 h-8' />
      </div>
      <h3 className='text-xl font-semibold mb-2'>
        {formatMessage(
          categoryMessages[`category${id}` as keyof typeof categoryMessages],
        )}
      </h3>
      <p className='text-gray-600 mb-4'>
        {formatMessage({
          id: 'serviceCard.description',
          defaultMessage: 'Найдите проверенных специалистов',
        })}
      </p>
      <button className='text-blue-600 flex items-center'>
        {formatMessage({
          id: 'serviceCard.details',
          defaultMessage: 'Подробнее',
        })}
        <ArrowRight className='w-4 h-4 ml-2' />
      </button>
    </div>
  );
}
